export function getProjectErrorMessages(variables: any) {
    return {
        "You can't delete this project because has estimates": variables.cannotDeleteProjectHasEstimates,
        "You do not have permission to perform this action": variables.notAuthorizedToDeleteProject
    };
}
